import React from 'react';

import { Grid2 as Grid, styled } from '@mui/material';

import { Line, MarkdownContainer, ResponsiveGrid } from '@mewa/ui';

type PressContactEntry = {
  data: {
    childMarkdownRemark: {
      html: string;
    };
  } | null;
};

export const PressContactContainer = ({
  title,
  mewaContact,
  communicationAgency,
}: {
  title: string;
  mewaContact: PressContactEntry;
  communicationAgency: PressContactEntry;
}) => (
  <ResponsiveGrid>
    <Grid size={12}>
      <Line sx={{ marginTop: ['80px', '150px'], marginBottom: 0 }} />
    </Grid>
    <Grid
      size={{
        xs: 12,
        md: 4,
      }}
    >
      <Title>{title}</Title>
    </Grid>

    <ContactSectionGrid size={{ xs: 12, md: 8 }}>
      <Grid container>
        {mewaContact.data && (
          <Grid
            sx={{ marginTop: ['22px', '70px'] }}
            size={{
              xs: 12,
              sm: 6,
            }}
          >
            <MarkdownContainerCustom
              html={mewaContact.data.childMarkdownRemark.html}
            />
          </Grid>
        )}
        {communicationAgency.data && (
          <>
            <Grid
              sx={{ display: ['block', 'none'], marginTop: '22px' }}
              size={12}
            >
              <Line />
            </Grid>
            <Grid
              sx={{ marginTop: ['22px', '70px'] }}
              size={{
                xs: 12,
                sm: 6,
              }}
            >
              <MarkdownContainerCustom
                html={communicationAgency.data.childMarkdownRemark.html}
              />
            </Grid>
          </>
        )}
      </Grid>
    </ContactSectionGrid>
  </ResponsiveGrid>
);

const MarkdownContainerCustom = styled(MarkdownContainer)(() => ({
  ':first-of-type': { marginTop: 0 },
  ':last-of-type': { marginBottom: 0 },
}));

const Title = styled('h4')(({ theme }) => ({
  ...theme.typography.h6,
  marginTop: '16px',

  [theme.breakpoints.up('sm')]: {
    marginTop: '20px',
  },
}));

const ContactSectionGrid = styled(Grid)(({ theme }) => ({
  [theme.breakpoints.up('lg')]: {
    maxWidth: '1167px',
  },
}));
